import i18n from '@/i18n';

import { readConfiguredCpuFromRecord } from '../../../capabilities/compute';
import type { PipelineContext } from '../../../core/types';
import { SubmitValidationError, resolveSubmitOverlayText } from '../../_shared/common/submit/submitValidation';
import type { CiSpec } from './schema';

/** 容器实例提交前必填校验（页面 validateSubmit / 直建提交前调用） */
export function assertCiSubmitReady(spec: CiSpec, ctx: PipelineContext): void {
  const name = resolveSubmitOverlayText(ctx.overlay?.name, ctx.overlay?.alias, spec.name);
  if (!name) {
    throw new SubmitValidationError('容器实例别名为必填项');
  }
  if (!spec.system?.url?.trim()) {
    throw new SubmitValidationError(i18n.t('data-center:please.select.system.image'));
  }
  const workspace = resolveSubmitOverlayText(ctx.overlay?.workspace, spec.workspace);
  if (!workspace) {
    throw new SubmitValidationError('租户空间为必填项');
  }
  if (!(spec.systemDiskSize && spec.systemDiskSize > 0)) {
    throw new SubmitValidationError('请配置系统盘');
  }
  if (!readConfiguredCpuFromRecord(spec.resource.cpu)) {
    throw new SubmitValidationError('请配置 CPU 资源');
  }
  const memoryGi =
    typeof spec.resource.memory === 'number' ? spec.resource.memory : Number(String(spec.resource.memory ?? '').replace(/Gi$/i, ''));
  if (!Number.isFinite(memoryGi) || memoryGi <= 0) {
    throw new SubmitValidationError('请配置内存资源');
  }
  const vpcName = spec.resource.network.vpc?.name?.trim();
  if (!vpcName) {
    throw new SubmitValidationError('请选择 VPC');
  }
}
